module.exports = __webpack_public_path__ + "images/cart-selected001ddb587c17ff076aa394497335b16e.png";